import React from "react";

const ChannelThree = () => (
  <div className="center">this is the ChannelThree</div>
);

export default ChannelThree;
